/** @format */

import {Box} from '@mui/material';

import CustomInfo from './CustomInfo';
import IdText from './IdText';

const AdGroup = props => {
  const sample = props.reportItemGroup[0];
  const showCustomInfo = sample.maxLocationField === 'adGroupId';

  return (
    <Box display='flex' flexDirection='column'>
      <IdText id={sample.adGroupId} text={sample.adGroup} />

      {showCustomInfo && (
        <CustomInfo reportItemGroup={props.reportItemGroup} sensorName={props.sensorName} />
      )}
    </Box>
  );
};

export default AdGroup;
